import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    menuresourceslist: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    portresourceslist: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pemiss: null,
    mobilemenulist: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      activeName: 'first',
      mesnuProps: {
        children: 'children',
        label: 'resourceName'
      },
      mesnlist: []
    };
  },
  methods: {
    handleClick: function handleClick() {},
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    },
    cancelDailog: function cancelDailog() {
      this.$emit('powerMaintainSubmit', {
        bool: false
      });
    },
    commit: function commit() {
      this.mesnlist = [];
      this.commitselected(this.menuresourceslist);
      this.commitselected(this.mobilemenulist);
      this.portselect();
      this.$emit('powerMaintainSubmit', {
        bool: true,
        selectlist: this.mesnlist
      });
    },
    commitselected: function commitselected(list) {
      var _this = this;
      if (list.length > 0) {
        // eslint-disable-next-line array-callback-return
        list.filter(function (item) {
          if (item.selected) {
            _this.mesnlist.push({
              id: item.id,
              permissionId: _this.pemiss.permissionId,
              resourceId: item.resourceId
            });
          }
          _this.commitselected(item.children);
        });
      }
    },
    portselect: function portselect() {
      var _this2 = this;
      // eslint-disable-next-line array-callback-return
      this.portresourceslist.filter(function (item) {
        if (item.selected) {
          _this2.mesnlist.push({
            id: item.id,
            permissionId: _this2.pemiss.permissionId,
            resourceId: item.resourceId
          });
        }
      });
    },
    selectmenu: function selectmenu(scope) {
      if (scope.row.children.length > 0) {
        this.handleCheckAll(scope.row);
      }
      scope.row.Indeterminate = false;
      if (this.activeName === 'first') {
        this.findselectnode(this.menuresourceslist, scope.row.id);
      } else {
        this.findselectnode(this.mobilemenulist, scope.row.id);
      }
    },
    handleCheckAll: function handleCheckAll(row) {
      var _this3 = this;
      if (row.children.length > 0) {
        // eslint-disable-next-line array-callback-return
        row.children.filter(function (item) {
          item.selected = row.selected;
          _this3.handleCheckAll(item);
        });
      }
    },
    // 递归寻找选中节点的父节点
    findselectnode: function findselectnode(nodelist, chiledid, father) {
      var _this4 = this;
      // eslint-disable-next-line array-callback-return
      nodelist.filter(function (item) {
        if (item.id === chiledid) {
          if (father) {
            var allselect = true;
            var allnotselect = true;
            // eslint-disable-next-line array-callback-return
            father.children.filter(function (item) {
              if (!item.selected) {
                allselect = false;
              }
              if (item.selected) {
                allnotselect = false;
              }
            });
            father.selected = allselect;
            if (allnotselect) {
              father.Indeterminate = false;
            } else {
              father.Indeterminate = !father.selected;
            }
            if (_this4.activeName === 'first') {
              _this4.findselectnode(_this4.menuresourceslist, father.id);
            } else {
              _this4.findselectnode(_this4.mobilemenulist, father.id);
            }
          }
        } else {
          if (item.children.length > 0) {
            _this4.findselectnode(item.children, chiledid, item);
          }
        }
      });
    }
  }
};